import SearchPage from "../SearchListings/SearchPage";
import { Import, Plus } from "lucide-react";
import { DataGenieIcon } from "src/components/icons";
import { useFeatureDiscovery } from "src/hooks/useFeatureDiscovery";
import FeatureDiscoveryTooltip from "../FeatureDiscoveryTooltip";
import useSearchListings from "../../hooks/useSearchListings";
import useSearchListingsPage from "../SearchListings/useSearchListingsPage";
import { useMemo } from "react";
import LinkButton from "../core/LinkButton";
import { EnumProductTypes } from "src/types/listing";
import ImportedListingDetails from "./ImportedListingDetails";
const SearchImportedListings = () => {
  const features = useMemo(() => ["start-new-lookup", "previous-lookups"], []);

  const { nextFeature, isLastFeature, shouldShowTooltip } =
    useFeatureDiscovery(features);

  const searchListings = useSearchListings({
    searchQueryKey: "getCustomUploadsListings",
    searchUrl: "/api/customupload/listing",
    productType: EnumProductTypes.customupload,
    includeLookupNameFilter: true,
    includeLookupSourceFilter: true,
  });

  const searchListingsPage = useSearchListingsPage({
    totalRecords: searchListings.totalRecords || 0,
    listings: searchListings.listings || [],
    csvApiUrl: searchListings.csvApiUrl,
    allListingsQuery: searchListings.allListingsQuery,
    fetchListingsInChunks: searchListings.fetchListingsInChunks,
    sortField: searchListings.sortField,
    sortDir: searchListings.sortDir,
    searchQueryKey: "getCustomUploadsListings",
    exportedCsvFileName: "customUploadslisting",
    productType: EnumProductTypes.customupload,
    searchCriteriaKey: searchListings.searchCriteriaKey,
  });

  return (
    <SearchPage
      searchListings={searchListings}
      searchListingsPage={searchListingsPage}
      pageTitle="Imported Contacts"
      pageTitleIcon={<DataGenieIcon style={{ fontSize: "19px" }} />}
      pageTitleButtons={
        <div className="flex gap-2">
          <FeatureDiscoveryTooltip
            content="View your previous lookups!"
            isOpen={shouldShowTooltip("previous-lookups")}
            onNext={nextFeature}
            isLast={isLastFeature}
          >
            <LinkButton
              variant="secondary"
              to="/data-genie/previous"
              icon={<Import />}
            >
              Previous Lookups
            </LinkButton>
          </FeatureDiscoveryTooltip>
          <FeatureDiscoveryTooltip
            content="Start a new Data Genie lookup"
            isOpen={shouldShowTooltip("start-new-lookup")}
            onNext={nextFeature}
            isLast={isLastFeature}
          >
            <LinkButton
              to="/data-genie/start"
              icon={<Plus />}
            >
              Start Lookup
            </LinkButton>
          </FeatureDiscoveryTooltip>
        </div>
      }
      PageTitleProps={{
        subtitle: "Data Genie",
      }}
      detailsPanelProvider={({
        detailsListingId,
      }) => (
        <ImportedListingDetails
          title="Imported"
          listingId={detailsListingId}
          isHideDNCPhoneNumbers={searchListings.isHideDNCPhoneNumbers}
        />
      )}
      propertyAmenitiesPropsProvider={() => ({
        isSuppressStatusInfo: true,
        toolbarPlacement: 'title',
      })}
    />
  );
};
export default SearchImportedListings;
